import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { useWorkspaceContext } from 'hooks/common';
import type { SparkAttribute, SingleSparkResponse } from 'types/Spark/Spark';

type mutationVariables = Partial<SparkAttribute>;

export function useAddSpark() {
  const queryClient = useQueryClient();

  const { currentWorkspaceID } = useWorkspaceContext();

  const addSpark = (sparkAttribute: mutationVariables) => {
    const body = {
      data: {
        type: 'sparks',
        attributes: sparkAttribute,
      },
    };

    return fetchWrapper<SingleSparkResponse>({
      url: `Sparks`,
      method: 'POST',
      body: body,
    });
  };

  return useMutation('addSpark', addSpark, {
    onSuccess: () => {
      queryClient.invalidateQueries(['sparks', currentWorkspaceID]);
    },

    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to add Spark: ${error.message}`);
      }
    },
  });
}
